import { useContext, useState } from 'react';
import { productions } from '../../sites/visactor/productions';
import { LanguageContext, LanguageEnum } from '../../utils';
import { copyWritings } from './copywritings';

import './index.less';

interface IProps {
  dropDown: boolean;
  [foo: string]: any;
}

export function ProductionPanel(props: IProps) {
  const { language, setLanguage } = useContext(LanguageContext);
  const [hovered, setHovered] = useState<string | null>(null);
  const { dropDown, style, ...restProps } = props;

  return (
    <div
      className={`visactor-navigator-production-container ${
        dropDown ? 'visactor-navigator-production-container-hovered' : ''
      }`}
      {...restProps}
      style={{
        height: dropDown
          ? language === LanguageEnum.chinese
            ? 420
            : 480
          : 0,
        ...(style ?? {}),
      }}
    >
      <div className="visactor-navigator-production-inner-container">
        {productions.map((production, index) => {
          return (
            <div
              style={{ display: 'flex', justifyContent: 'center' }}
              key={index}
            >
              <div
                className="visactor-navigator-production"
                onMouseOver={() =>
                  !production.comingSoon && setHovered(production.name)
                }
                onMouseOut={() => !production.comingSoon && setHovered(null)}
                onClick={() => {
                  if (production.link) {
                    window.open(
                      production.link,
                      '_blank',
                      'noopener,noreferrer'
                    );
                    return;
                  }
                  !production.comingSoon &&
                    window.open(`/${production.name.toLocaleLowerCase()}`);
                }}
                style={{
                  gridRowStart: (index + 1) % 3,
                  gridRowEnd: ((index + 1) % 3) + 1,
                  gridColumnStart: Math.floor(index / 3) + 1,
                  gridColumnEnd: Math.floor(index / 3) + 2,
                  ...(index < 4
                    ? {
                        borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                        paddingBottom: 24,
                        marginBottom: 24,
                      }
                    : {}),
                }}
              >
                <div className="visactor-navigator-production-logo">
                  <img src={production.icon} />
                </div>
                <a
                  href={`/${production.name.toLocaleLowerCase()}`}
                  className="visactor-navigator-production-title"
                  onClick={(event) => event.preventDefault()}
                  style={{
                    fontFamily:
                      language === LanguageEnum.chinese
                        ? 'Source Han Sans CN'
                        : 'Montserrat',
                    color: hovered === production.name ? '#002AFF' : '#000',
                  }}
                >
                  {production.name}{' '}
                  <span
                    style={{
                      fontWeight: 400,
                      fontStyle:
                        language !== LanguageEnum.chinese ? 'italic' : 'normal',
                    }}
                  >
                    {production.alias[language]}
                    {production.comingSoon ? copyWritings.soon[language] : null}
                  </span>
                </a>
                <p
                  className="visactor-navigator-production-description"
                  style={{
                    fontFamily:
                      language === LanguageEnum.chinese
                        ? 'Source Han Sans CN'
                        : 'Montserrat',
                  }}
                >
                  {production.description[language]}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
